import queryString from "query-string";
import { compressForUrl, decompressFromUrl } from './urlCompression';

const addUrlParam = (name, param) => {
  const params = new URLSearchParams(window.location.search);

  // Compress filter parameters for Incoming Orders page
  if (name === 'filter' && typeof param !== "string" && window.location.pathname.includes('incoming-orders')) {
    const compressed = compressForUrl(param);
    console.log('[URL Compression] Original:', JSON.stringify(param).length, 'chars, Compressed:', compressed.length, 'chars');
    params.set(name, compressed);
  } else {
    params.set(
      name, typeof param !== "string" ? JSON.stringify(param) : param
    );
  }

  window.history.replaceState(null, null, "?"+params.toString())
}

const getTableUrlParams = (search) => {
  const {
    searchText,
    filter,
    chipFilters
  } = queryString.parse(search);

  // Decompress filter if it's compressed (for Incoming Orders page)
  let parsedFilter = {};
  if (filter) {
    parsedFilter = decompressFromUrl(filter);
  }

  // Parse chipFilters if present
  let parsedChipFilters;
  if (chipFilters) {
    try {
      parsedChipFilters = JSON.parse(chipFilters);
    } catch (err) {
      console.error('Failed to parse chipFilters', err);
    }
  }

  return {
    searchText: searchText || "",
    filter: parsedFilter,
    chipFilters: parsedChipFilters
  }
}

const getUrlWithParams = (name, param) => {
  const params = new URLSearchParams(window.location.search);

  // Compress filter parameters for Incoming Orders page
  if (name === 'filter' && typeof param !== "string" && window.location.pathname.includes('incoming-orders')) {
    params.set(name, compressForUrl(param));
  } else {
    params.set(
      name, typeof param !== "string" ? JSON.stringify(param) : param
    );
  }

  return params.toString();
}

export {
  getTableUrlParams,
  addUrlParam,
  getUrlWithParams
}
